import type { ToolCallMessagePartProps } from '@assistant-ui/react';
import { IconDatabaseShare } from '@tabler/icons-react';

import { ToolDisplay } from '#plugin-chat/components/tool-display/ToolDisplay.tsx';
import { ViewExternalIdBadgeList } from '#plugin-chat/components/tool-display/ViewExternalIdBadge.tsx';
import type {
  QueryKnowledgeGraphOutput,
  QueryKnowledgeGraphParameters,
} from '#plugin-chat/components/tools/query-knowledge-graph/schema.ts';
import type { ToolProgressComponent } from '#plugin-chat/lib/tool/progress-registry.ts';

/**
 * UI component for QueryKnowledgeGraphTool.
 */
export function RenderQueryKnowledgeGraphTool({
  args,
}: ToolCallMessagePartProps<QueryKnowledgeGraphParameters, QueryKnowledgeGraphOutput>) {
  const viewExternalId = args?.viewExternalId;
  const rowCount = undefined;

  const rowSuffix = rowCount === undefined ? undefined : ` · ${rowCount} rows`;

  return (
    <ToolDisplay>
      <ToolDisplay.Running>
        <span>Looking up data...</span>
        <ViewExternalIdBadgeList externalIds={[viewExternalId]} />
      </ToolDisplay.Running>
      <ToolDisplay.Complete color="var(--mantine-color-grape-3)" icon={IconDatabaseShare}>
        <div>
          <span>Data lookup completed</span>
          <ViewExternalIdBadgeList externalIds={[`${viewExternalId} ${rowSuffix ?? ''}`]} />
        </div>
      </ToolDisplay.Complete>
      <ToolDisplay.Error>Data lookup failed</ToolDisplay.Error>
    </ToolDisplay>
  );
}
/**
 * Progress component for QueryKnowledgeGraphTool.
 *
 * Rendered inside the "AiPSO Agent is ..." progress bubble while the tool is running.
 */
export const ProgressQueryKnowledgeGraphTool: ToolProgressComponent<
  QueryKnowledgeGraphParameters,
  QueryKnowledgeGraphOutput
> = () => <>looking up data...</>;
